import { createStore } from "vuex";
import Vue from "vue";

const store = createStore({
    state: {
        invoice: {},
    },
    actions: {},
    mutations: {
        setInvoice(state, invoice) {
            state.invoice = invoice;
        },
    },
    getters: {
        getItems: (state) => state.invoice?.items ?? [],
        getInvoice: (state) => state.invoice
    },
    strict: true
});

export default store;
